// src/firebase.ts
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

//production config
const firebaseConfig = {
  apiKey:    "AIzaSyAizDg80mrhhtTad0FTebvqeqfniA5PuB8",
  authDomain: "stakeholdernet.firebaseapp.com",
  projectId:  "stakeholdernet",
  storageBucket: "stakeholdernet.firebasestorage.app",
  messagingSenderId: "606550382904",
  appId:    "1:606550382904:web:d8b722e144a68ca5e849cd"
};

//staging config
const stagingConfig = {
  apiKey: "AIzaSyCdglzubi5Q0s2om1qjOTXWKKbQQNFxSzk",
  authDomain: "stakeholdernet-staging.firebaseapp.com",
  projectId: "stakeholdernet-staging",
  storageBucket: "stakeholdernet-staging.firebasestorage.app",
  messagingSenderId: "840448031648",
  appId: "1:840448031648:web:3adfb2583548b19de802c5"
};

// Decide which config to use. Runtime override via ?env=staging|prod or localStorage "firebaseEnv".
// Falls back to hostname check (contains "staging").
const getEnvPreference = () => {
  const host = window.location.hostname;
  const isLocal = host === "localhost" || host === "127.0.0.1";

  // On hosted environments, lock to the host-detected env; no overrides allowed.
  if (!isLocal) {
    return host.includes("staging") ? "staging" : "prod";
  }

  // Local: allow temporary overrides.
  const params = new URLSearchParams(window.location.search);
  const paramEnv = params.get("env");
  if (paramEnv === "staging" || paramEnv === "prod") {
    localStorage.setItem("firebaseEnv", paramEnv);
    return paramEnv;
  }
  const storedEnv = localStorage.getItem("firebaseEnv");
  if (storedEnv === "staging" || storedEnv === "prod") return storedEnv;
  // Default local behavior: staging unless explicitly flipped
  return isLocal ? "staging" : "prod";
};

export const firebaseEnv = getEnvPreference();
const isStaging = firebaseEnv === "staging";
const config = isStaging ? stagingConfig : firebaseConfig;

// Initialize the app once
const app = initializeApp(config);

// Export the **v10 modular** instances
export const auth = getAuth(app);
export const db   = getFirestore(app);

// (optional) expose for debugging
/*
;(window as any).firebaseAuthInstance = auth;
;(window as any).firebaseDbInstance   = db;
*/
